import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="py-28 md:py-40 bg-bg-light">
      <div className="container mx-auto px-6 text-center">
        <div className="flex flex-col items-center animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-medium text-slate-800 mb-4">
            Social Media Manager
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Expert in managing platforms like Facebook, Instagram and TikTok,
            crafting creative content using Figma, Canva and Capcut.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero; 